import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetMaternityDetails = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_UWMATERNITY_DETAILS, token);
  return res;
};

export const GetMaternityDetail = async (maternityId) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_UWMATERNITY_DETAILS_BY_ID + maternityId,
    token
  );
  return res;
};

export const AddMaternity = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_UWMATERNITY, payload, token);
  return res;
};

export const DeleteMaternity = async (maternityId) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(
    Url.DELETE_UWMATERNITY + maternityId,
    maternityId,
    token
  );
  return res;
};

export const UpdateMaternity = async (maternityId, payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(
    Url.UPDATE_UWMATERNITY + maternityId,
    payload,
    token
  );
  return res;
};
